import React from 'react';
import { Image } from "primereact/image";
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import './Demo.css'

// TODO: THIS IS A PLACEHOLDER IMAGE
const thinkhausLogo = require('../../assets/th-logo.png');

const Demo = () => {
    const navigate = useNavigate()
    return (
        <div
            className='relative flex flex-column justify-content-center w-screen h-screen'
            style={{ background: "linear-gradient(135deg, #66328F 0%, #3c1e54 50%, #1e0f2a 100%)" }}
        >
            <div className='flex flex-column justify-content-center align-items-center' >
                <Image
                    className='white-icon w-20rem h-auto'
                    imageClassName='w-full h-full'
                    src={thinkhausLogo}
                    alt='Thinkhaus Logo'
                />
                <h1 className='text-white text-8xl mt-0'>THINKHAUS AI</h1>
                <Button
                    onClick={() => navigate('traditional-approach')}
                    style={{backgroundImage: 'linear-gradient(180deg, #50C4CA 0%, #2BAAE2 100%)', color: '#000'}}
                    label='BEGIN'
                    pt={{icon: {style: {color: '#000'}}}}
                    icon='pi pi-chevron-right'
                    iconPos='right'
                    rounded
                />
            </div>
            <p className='absolute bottom-0 text-white p-4 text-2xl font-light'
            >
                PATENT-PENDING
            </p>
        </div>
    )
}

export default Demo;